import React from "react"

export default function PersonDisable() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8_289)">
        <path d="M15.1787 8.50257C15.1787 7.08257 14.6787 5.77257 13.8487 4.74257C14.2687 4.60257 14.7087 4.50257 15.1787 4.50257C17.3887 4.50257 19.1787 6.29257 19.1787 8.50257C19.1787 10.7126 17.3887 12.5026 15.1787 12.5026C15.1187 12.5026 15.0587 12.5026 14.9987 12.5026L14.2287 11.7326C14.8287 10.7926 15.1787 9.68257 15.1787 8.50257ZM23.0087 20.5026H23.1787V17.5026C23.1787 15.3226 19.5987 14.0326 16.8387 13.6326C17.9387 14.3826 18.7887 15.3426 19.0687 16.5726L23.0087 20.5026ZM7.41874 4.91257C7.94874 4.65257 8.54874 4.50257 9.17874 4.50257C11.3887 4.50257 13.1787 6.29257 13.1787 8.50257C13.1787 9.13257 13.0287 9.73257 12.7687 10.2626L7.41874 4.91257ZM9.34874 12.5026C9.28874 12.5026 9.23874 12.5026 9.17874 12.5026C6.96874 12.5026 5.17874 10.7126 5.17874 8.50257C5.17874 8.44257 5.17874 8.39257 5.17874 8.33257L0.868744 4.01257L2.27874 2.60257L22.0787 22.4026L20.6687 23.8126L17.1787 20.3326V20.5026H1.17874V17.5026C1.17874 14.8426 6.50874 13.5026 9.17874 13.5026C9.54874 13.5026 9.97874 13.5326 10.4287 13.5826L9.34874 12.5026Z" fill="#5B5E71" />
      </g>
      <defs>
        <clipPath id="clip0_8_289">
          <rect width="24" height="24" fill="white" transform="translate(0.178711 0.502441)" />
        </clipPath>
      </defs>
    </svg>

  )
}
